import moment from "moment/moment";

export const logInHelper = () => {
      const singInDate = localStorage.getItem('signin-date')
      const currentTime = moment()
      const isLogIn = currentTime.diff(moment(singInDate).add(6, 'hours'), 'minutes') <= 1 && singInDate !== null ? true : false
      return isLogIn
}

export const adminLogInHelper = () => {
      const singInDate = localStorage.getItem('signin-date')
      const role = JSON.parse(localStorage.getItem('user')).role
      const currentTime = moment()
      const isAdminLogIn = currentTime.diff(moment(singInDate).add(6, 'hours'), 'minutes') <= 1 && (singInDate !== null) && (role === "Admin")  ? true : false
      return isAdminLogIn
}